import { ReactComponent as PhantomSvg } from "./Phantom_SVG_Icon.svg";

const SolanaPhantomIcon = ({ props }) => (
  <PhantomSvg
    width="100%"
    height="100%"
    {...props}
    style={{ display: "block", ...(props?.style || {}) }}
  />
);

export default SolanaPhantomIcon;
